import { render } from "./SiteManage.vue?vue&type=template&id=72169952"
import script from "./SiteManage.vue?vue&type=script&setup=true&lang=js"
export * from "./SiteManage.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/SitesDash/SiteManage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "72169952"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('72169952', __exports__)) {
    api.reload('72169952', __exports__)
  }
  
  module.hot.accept("./SiteManage.vue?vue&type=template&id=72169952", () => {
    api.rerender('72169952', render)
  })

}


export default __exports__